module.exports = __webpack_public_path__ + "img/logo.cff65ea4.png";